// const SERVER_URL = 'https://tivadevapi.azurewebsites.net/'
const SERVER_URL = process.env.REACT_APP_API_URL
export const AUTHENTICATION_LINK_URL = `${SERVER_URL}Auth/`;
export const LISTS_URL = `${SERVER_URL}Api/Lists/`;
export const LOGS_URL = `${SERVER_URL}Api/Logs/`;
export const MEDS_URL = `${SERVER_URL}Api/Meds/`;
export const RECAPTCHA_URL = `${SERVER_URL}recaptcha/verify/`;
export const EXTERNAL_LOG_URL = `${SERVER_URL}log/external/`;
